(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// 新規ページ用
(function($) {
  let slug = window.location.pathname;

  var nav = $('#js-menu-trigger'),
    icon = $('#menu-icon'),
    mobileNav = $('#nav-header'),
    header = $('.header'),
    navItems = { 1: nav, 2: icon, 3: mobileNav, 4:header };

  nav.click(function (e) {
    e.preventDefault();
    if (!nav.hasClass('js-active')) {
      $.each(navItems, function (index, element) {
        element.addClass('js-active');
      });
    } else {
      $.each(navItems, function (index, element) {
        element.removeClass('js-active');
      });
    }
  });

  // トップページ member hover

  if(window.innerWidth > 768 ) {
    $('.front-member-item-hover').on('mouseenter', function (e) {
      return false;
    });

    $('.front-member-item').on('mouseenter', function () {
      var item = $(this).find('.front-member-item-hover');
      item.addClass('js-active');
    });

  }
  else {
     $('.front-member-item').on('click', function() {
      var item = $(this).find('.front-member-item-hover');
      if (!item.hasClass('js-active')) {
        item.addClass('js-active');
      }
     });
  }


  $('.front-member-item-hover-close').on('click', function (e) {
    $(this).parents('.front-member-item-hover').removeClass('js-active');
    $(this).parents('.front-member-item > img').off('mouseenter');
    e.stopPropagation();
  });

  // infinite scroll
  if (
    slug.indexOf('news') > -1 ||
    slug.indexOf('category') > -1
  ) {
    $('.news-archive-items').infiniteScroll({
      path: '.archive-next-posts a',
      append: '.news-archive-item',
      history: false,
      scrollThreshold: false,
      button: '.archive-more',
      status: '.archive-load-status',
    });
  }

  if (slug.indexOf('result') > -1 || slug.indexOf('result-game') > -1) {
    $('.result-archive-items').infiniteScroll({
      path: '.archive-next-posts a',
      append: '.result-archive-item',
      history: false,
      scrollThreshold: false,
      button: '.archive-more',
      status: '.archive-load-status',
    });
  }

  // cotact
  if(slug.indexOf('contact') > -1) {
    $('.faq-item-question').on('click', function() {
      var faq_content = $(this).next('.faq-item-answer');
      $(faq_content).slideToggle();

      if($(this).hasClass('close')) {
        $(this).removeClass('close');
      }
      else {
        $(this).addClass('close');
      }
    });
  }

  // swiperスライダー
  var swiper1 = new Swiper('.kv-swiper', {
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    speed: 800,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  var swiper3 = new Swiper('.front-member-swiper', {
    spaceBetween: 0,
    loop: true,
    speed: 10000,
    centeredSlides: true,
    allowTouchMove: true,
    slidesPerView: 1.2,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      430: {
        slidesPerView: 1.5,
      },

      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2.5,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3.5,
      },
      1400: {
        slidesPerView: 4.5,
      },
      1600: {
        slidesPerView: 5.5,
      },
    },
  });

  var swiper4 = new Swiper('.front-video-swiper', {
    spaceBetween: 0,
    loop: true,
    speed: 10000,
    slidesPerView: 1.2,
    allowTouchMove: true,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      // 430: {
      //   slidesPerView: 1.2,
      // },

      576: {
        slidesPerView: 2.2,
      },
    },
  });

  var swiper5 = new Swiper('.entry-swiper-thumb', {
    spaceBetween: 5,
    loop: true,
    slidesPerView: 6,
  });

  var swiper6 = new Swiper('.entry-swiper', {
    spaceBetween: 10,
    loop: true,
    initialSlide: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper5,
    },
  });

  // ホーム選手欄高さ調整
  function front_member_hover_height() {
    var front_member_hover_height = $(
      '.front-member-item-inner > img'
    ).height();

    var front_member_item_hover_padding = $('.front-member-item-hover').css(
      'padding'
    );

    if (front_member_item_hover_padding) {
      front_member_item_hover_padding = Number(
        front_member_item_hover_padding.replace('px', '')
      );

      $('.front-member-item-hover-inner').innerHeight(
        front_member_hover_height - front_member_item_hover_padding * 2
      );
    }
  }

  $(window).on('resize load', front_member_hover_height);


  //Sticky header background color change
  $(window).on('scroll', function () {
    if ($('.kv-container').height() < $(this).scrollTop()) {
      $('.nav-header-top').addClass('js-active');
    } else {
      $('.nav-header-top').removeClass('js-active');
    }
  });

  // viewport
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 375
        ? 'width=device-width,initial-scale=1'
        : 'width=375';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();

  // Set hero images as background images
  var images = $('.kv-image-item'),
    max_count = images.length - 1;

  // トップへ戻るボタン
  $('#js-back-to-top').click(function (event) {
    event.preventDefault;
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });


  // new ScrollHint('.js-scrollable', {
  //   scrollHintIconAppendClass: 'scroll-hint-icon-white', // white-icon will appear
  //   applyToParents: true,
  //   i18n: {
  //     scrollable: 'スクロールできます',
  //   },
  // });

})(jQuery); // Fully reference jQuery after this point.
},{}]},{},[1]);
